module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/text_black-620e85f6b4284a43f22040c2eaf28835.png";